import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {globalDataSelector} from "../../../../redux/slices/globalDataSlice";
import Header from "../../../../components/Partials/Header/Header";
import SvgSelector from "../../../../components/SvgSelector/SvgSelector";
import ConfirmPopup from "../../../../components/UiKit/Popups/ConfirmPopup/ConfirmPopup";
import ActivateSubscriptionTopUpBalancePopup
    from "../../../../components/UiKit/Popups/ActivateSubscriptionTopUpBalancePopup/ActivateSubscriptionTopUpBalancePopup";
import subscriptionsPurpleBG from '../../../../assets/img/subscriptionsPurpleBG.png'
import subscriptionsGreenBG from '../../../../assets/img/subscriptionsGreenBG.png'
import subscriptionsSlateBG from '../../../../assets/img/subscriptionsSlateBG.png'
import subscriptionsDisabledSlateBG from '../../../../assets/img/subscriptionsDisabledSlateBG.png'
import subscriptionsRedBG from '../../../../assets/img/subscriptionsRedBG.png'
import subscriptionsDisabledRedBG from '../../../../assets/img/subscriptionsDisabledRedBG.png'
import subscriptionsBlueBG from '../../../../assets/img/subscriptionsBlueBG.png'
import subscriptionsDisabledBlueBG from '../../../../assets/img/subscriptionsDisabledBlueBG.png'
import s from './subscriptions.module.scss'
import {
    activateSubscription, changePaymentMethod,
    disableAutoRenewSubscription,
    enableAutoRenewSubscription, getSubscriptionPaymentMethodStatus,
    renewSubscription, setChangePaymentMethodStatus,
    setFreeDomainsCount,
    setIsInitialInstallsLimits, setPaymentMethodNow, setPaymentMethodToChange, setSubscriptionPaymentMethodStatus,
    setWasSubscriptionActivated,
    subscriptionSelector, switchToPerInstallPayment,
    updateSubscriptionsListAfterActivation,
    updateSubscriptionsListAfterDisablingAutoRenew,
    updateSubscriptionsListAfterEnablingAutoRenew
} from "../../../../redux/slices/subscriptionSlice";
import CustomSkeleton from "../../../../components/UiKit/CustomSkeleton/CustomSkeleton";
import {isDateAtLeastOneDayOlder} from "../../../../utils/helpers/dateHelpers";
import {
    activateSubscriptionUnsufficientFunds,
    unavailableTestSubscriptionActivation
} from "../../../../utils/vars/errorMessages";
import {getLanguage} from "../../../../storage/switchLanguage";
import {convertDate} from "../../../../utils/helpers/formatTime";
import {removeSubscriptionEndingLimits} from "../../../../storage/subscription";
import {snackbar_success, snackbar_warning, SUBSCRIPTION_PAYMENT_METHOD} from "../../../../utils/vars/staticVariables";
import useCustomSnackbar from "../../../../hooks/useCustomSnackbar";
import {removeAllInstallsIsNotified} from "../../../../storage/installsLimits";
import SubscriptionActivatedPopup
    from "../../../../components/UiKit/Popups/SubscriptionActivatedPopup/SubscriptionActivatedPopup";

export const ANDROID = 'Android Star'
export const START = 'Start'
export const WILD = 'Wild Star'

export const subscriptionsInfoList = [
    {
        name: 'Test',
        description: 'Начните успешный запуск уже сейчас!',
        benefitsName: "Вы получаете доступ к приложениям, включающим:",
        bgImage: subscriptionsPurpleBG,
        extraBenefits: {
            name: '',
            benefitsList: []
        }
    },
    {
        name: START,
        description: 'subscriptions_info.start_tariff.desc',
        benefitsName: "subscriptions_info.start_tariff.benefits_name",
        bgImage: subscriptionsSlateBG,
        disabledBgImage: subscriptionsDisabledSlateBG,
        extraBenefits: {
            extraBenefitsName: '',
            extraBenefitsList: [
                'uac_access',
                'presence_10_team_members'
            ]
        },
    },
    {
        name: ANDROID,
        description: 'subscriptions_info.android_star_tariff.desc',
        benefitsName: "subscriptions_info.android_star_tariff.benefits_name",
        bgImage: subscriptionsBlueBG,
        disabledBgImage: subscriptionsDisabledBlueBG,
        extraBenefits: {
            extraBenefitsName: '',
            extraBenefitsList: [
                'access_to_other_android_sources',
                'private_fb_developers_5_pcs',
                'presence_10_team_members'
            ]
        }
    },
    {
        name: WILD,
        description: 'subscriptions_info.wild_star_tariff.desc',
        benefitsName: "subscriptions_info.wild_star_tariff.benefits_name",
        bgImage: subscriptionsRedBG,
        disabledBgImage: subscriptionsDisabledRedBG,
        extraBenefits: {
            extraBenefitsName: 'А также:',
            extraBenefitsList: [
                'priority_issuance_of_android_sources',
                'retention_manager',
                'free_domains_ios_pwa',
                'private_fb_developers',
                'presence_20_team_members'
            ]
        }
    }
]

export const subscriptionLimits = [
    {
        iconId: 'google-play-limit-icon',
        defaultKey: 'android_install_count',
        subscriptionKey: 'subscription_android_install_count'
    },
    {
        iconId: 'app-store-limit-icon',
        defaultKey: 'ios_install_count',
        subscriptionKey: 'subscription_ios_install_count'
    },
    {
        iconId: 'pwa-limit-icon',
        defaultKey: 'pwa_install_count',
        subscriptionKey: 'subscription_pwa_install_count'
    }
];

const Subscriptions = () => {
    const [isSubscriptionsTopUpBalancePopupActive, setSubscriptionsTopUpBalancePopupActive] = useState(false);
    const [isConfirmSubscriptionActive, setConfirmSubscriptionActive] = useState(false);
    const [isSwitchToPerInstallPaymentPopupActive, setSwitchToPerInstallPaymentPopupActive] = useState(false);
    const [isCancelSwitchToSubscriptionPopupActive, setCancelSwitchToSubscriptionPopupActive] = useState(false);
    const [isDisableAutoRenewSubscriptionPopupActive, setDisableAutoRenewSubscriptionPopupActive] = useState(false);
    const [isEnableAutoRenewSubscriptionPopupActive, setEnableAutoRenewSubscriptionPopupActive] = useState(false);
    const [selectedTariff, setSelectedTariff] = useState({});
    const [notifyingModePopupData, setNotifyingModePopupData] = useState({});
    const [isNotifyingModePopupActive, setNotifyingModePopupActive] = useState(false);
    const [isRenewSubscription, setRenewSubscription] = useState(false);
    const [isTestTariffJustActivate, setTestTariffJustActivate] = useState(false);
    // const [isResetCounters, setIsResetCounters] = useState(false);
    const [activateSubscriptionPending, setActivateSubscriptionPending] = useState(false);
    const [switchToPerInstallPaymentPending, setSwitchToPerInstallPaymentPending] = useState(false);
    const [cancelSwitchToSubscriptionPending, setCancelSwitchToSubscriptionPending] = useState(false);
    const [disableAutoRenewSubscriptionPending, setDisableAutoRenewSubscriptionPending] = useState(false);
    const [enableAutoRenewSubscriptionPending, setEnableAutoRenewSubscriptionPending] = useState(false);
    const showSnackbar = useCustomSnackbar();
    const dispatch = useDispatch();
    const {isCollapsedSidebar} = useSelector(globalDataSelector);
    const {
        subscriptionsList,
        fetchSubscriptionsPending,
        isInitialInstallsLimits,
        isPaymentPerInstallationSubMode,
        paymentPerInstallationSubModePending,
        changePaymentMethodInfoPending,
        payment_method_to_change,
        payment_method_now,
        change_payment_method_status
    } = useSelector(subscriptionSelector);

    const {t} = useTranslation();

    // const activeSubscription = subscriptionsList.find(item => item?.is_active && item?.active_by_time)
    const activeSubscription = subscriptionsList.find(item => item?.is_active)


    const testTariff = subscriptionsList.find(({name}) => name === 'Test')
    const majorSubscriptions = subscriptionsList.filter(({name}) => name !== 'Test')

    const displayInstalls = (count) =>
        Number.isFinite(count) ? `${count} ${t('subscription_installs_counter')}` : "All in";

    const onActivateSubscription = (tariffName) => {
        const selectedTariff = subscriptionsList.find(({name}) => name === tariffName)
        setSelectedTariff(selectedTariff)
        setConfirmSubscriptionActive(true)
    }

    const onDisableAutoRenewSubscription = (tariffName) => {
        const selectedTariff = subscriptionsList.find(({name}) => name === tariffName)
        setSelectedTariff(selectedTariff)
        setDisableAutoRenewSubscriptionPopupActive(true)
    }

    const onEnableAutoRenewSubscription = (tariffName) => {
        const selectedTariff = subscriptionsList.find(({name}) => name === tariffName)
        setSelectedTariff(selectedTariff)
        setEnableAutoRenewSubscriptionPopupActive(true)
    }

    const subscriptionPaymentMethodToChange = subscriptionsList.find(({name}) => name === payment_method_to_change)


    const isSubscriptionWithoutChangingPaymentMethod = !change_payment_method_status && payment_method_now === 'Subscription' && payment_method_to_change === 'No'

    const processSubscriptionAction = async () => {
        const resetActivationState = () => {
            setActivateSubscriptionPending(false);
            setConfirmSubscriptionActive(false);
        };

        const {name, id} = selectedTariff;
        const dataObj = {
            packet_name: name,
            subscribe_months: 1,
            renew_subscription: true,
        };

        setActivateSubscriptionPending(true);

        let requestResult;

        // if (subscriptionPaymentMethodToChange) {
        // if (payment_method_now === 'Subscription') {
        if (isSubscriptionWithoutChangingPaymentMethod) {
            // Если нужно менять метод подписки
            const action = isRenewSubscription ? renewSubscription : activateSubscription;
            requestResult = await dispatch(
                action(isRenewSubscription ? id : dataObj)
            ).unwrap();
        } else {
            // const {status} = await dispatch(changePaymentMethod('No')).unwrap()

            requestResult = await dispatch(changePaymentMethod(name)).unwrap();

            // В противном случае — переключаем на поинстальную оплату
            // requestResult = await dispatch(
            //     isRenewSubscription
            //         ? renewSubscription(id)
            //         : changePaymentMethod(name)
            // ).unwrap();
        }

        const {data, status} = requestResult

        // const action = isRenewSubscription ? renewSubscription : activateSubscription;
        //
        // const {data, status} = await dispatch(action(isRenewSubscription ? id : dataObj)).unwrap();
        // const {
        //     data,
        //     status
        // } = await dispatch(isRenewSubscription ? renewSubscription(id) : switchToPerInstallPayment({isPaymentPerInstallationSubMode: '', subscription: name})).unwrap();

        const freeDomainsCount = data?.user_limits?.free_domains

        if (status === 200) {
            removeSubscriptionEndingLimits()
            removeAllInstallsIsNotified()
            setTimeout(() => {
                if (!activeSubscription) {
                    dispatch(setIsInitialInstallsLimits(true))
                }
                if (isSubscriptionWithoutChangingPaymentMethod) {
                    dispatch(updateSubscriptionsListAfterActivation(data));
                    dispatch(setWasSubscriptionActivated(true))
                } else {
                    dispatch(setChangePaymentMethodStatus(true))
                    dispatch(setPaymentMethodToChange(name))
                }
                if (data?.subscription_name === 'Test') {
                    setTestTariffJustActivate(true)
                }
                if (isRenewSubscription) {
                    dispatch(setIsInitialInstallsLimits(true))
                }
                resetActivationState();
                setNotifyingModePopupData({
                    title: isRenewSubscription ? 'tariff_renewal' : 'tariff_activation',
                    description: isRenewSubscription
                        ? 'tariff_renewed'
                        : isSubscriptionWithoutChangingPaymentMethod
                            ? 'tariff_activated' :
                            `${t('switch_to_subscription_will_take_place_at_00_00')}
                    ${
                                convertDate(tomorrow, 'DMY')
                            }.
                `,
                    secret_key: data?.secret_key,
                    subscription_name: data?.subscription_name,
                });
                setNotifyingModePopupActive(true);
                if (freeDomainsCount) {
                    dispatch(setFreeDomainsCount(freeDomainsCount))
                } else {
                    dispatch(setFreeDomainsCount(0))
                }
            }, 2000);
        } else if (data?.detail === activateSubscriptionUnsufficientFunds) {
            setTimeout(() => {
                resetActivationState();
                setSubscriptionsTopUpBalancePopupActive(true);
            }, 1000);
        } else if (data?.detail === unavailableTestSubscriptionActivation) {
            setTimeout(() => {
                resetActivationState();
                setNotifyingModePopupData({
                    title: 'tariff_activation',
                    description: 'unable_to_activate_test_subscription',
                });
                setNotifyingModePopupActive(true);
            }, 1000);
        } else {
            setTimeout(() => {
                resetActivationState();
                setNotifyingModePopupData({
                    title: isRenewSubscription ? 'tariff_renewal' : 'tariff_activation',
                    description: isRenewSubscription ? 'tariff_renewal_error' : 'tariff_activation_error',
                    support: true,
                });
                setNotifyingModePopupActive(true);
            }, 1000);
        }
    };


    const disableAutoRenewSubscriptionHandler = async () => {
        const {id} = selectedTariff

        setDisableAutoRenewSubscriptionPending(true)

        const {status} = await dispatch(disableAutoRenewSubscription(id)).unwrap();

        if (status === 200) {
            setTimeout(() => {
                dispatch(updateSubscriptionsListAfterDisablingAutoRenew(selectedTariff?.name))
                setDisableAutoRenewSubscriptionPopupActive(false)
                setDisableAutoRenewSubscriptionPending(false)
                setNotifyingModePopupData({
                    title: 'subscription_auto_renewal_popup_title',
                    description: 'you_disabled_subscription_auto_renewal',
                })
                setNotifyingModePopupActive(true)
            }, 2000)
        } else {
            setTimeout(() => {
                setNotifyingModePopupData({
                    title: 'subscription_auto_renewal_popup_title',
                    description: 'disable_auto_renewal_error',
                    support: true
                })
                setDisableAutoRenewSubscriptionPending(false)
                setDisableAutoRenewSubscriptionPopupActive(false)
                setNotifyingModePopupActive(true)
            }, 1000)
        }
    }

    const enableAutoRenewSubscriptionHandler = async () => {
        const {id} = selectedTariff

        setEnableAutoRenewSubscriptionPending(true)

        const {status} = await dispatch(enableAutoRenewSubscription(id)).unwrap();

        if (status === 200) {
            setTimeout(() => {
                dispatch(updateSubscriptionsListAfterEnablingAutoRenew(selectedTariff?.name))
                setEnableAutoRenewSubscriptionPopupActive(false)
                setEnableAutoRenewSubscriptionPending(false)
                setNotifyingModePopupData({
                    title: 'subscription_auto_renewal_popup_title',
                    description: 'you_enabled_auto_renewal',
                })
                setNotifyingModePopupActive(true)
            }, 2000)
        } else {
            setTimeout(() => {
                setNotifyingModePopupData({
                    title: 'subscription_auto_renewal_popup_title',
                    description: 'enable_auto_renewal_error',
                    support: true
                })
                setEnableAutoRenewSubscriptionPending(false)
                setEnableAutoRenewSubscriptionPopupActive(false)
                setNotifyingModePopupActive(true)
            }, 1000)
        }
    }

    const isDisabledButtons = disableAutoRenewSubscriptionPending || enableAutoRenewSubscriptionPending || activateSubscriptionPending || changePaymentMethodInfoPending

    const isTestSubscriptionHidden = (testTariff?.start_date && !testTariff?.is_active)
        || majorSubscriptions?.some(obj => obj.is_active || obj.start_date);

    const installTypes = ['PWA', 'IOS', 'ANDROID'];

    const testSubscriptionInstallsList = installTypes.map(installName => {
        const countKey = `subscription_${installName.toLowerCase()}_install_count`

        return {
            installName,
            count: testTariff?.[countKey],
        };
    });

    const startDateOfSubscription = convertDate(activeSubscription?.start_date, 'DMY')
    const endDateOfSubscription = convertDate(activeSubscription?.end_date, 'DMY')

    const canBuySubscription = (selectedSubscriptionIndex) => {
        const subscriptionsWithEndDate = majorSubscriptions.filter(sub => sub.end_date);

        const highestEndDateSubscription = subscriptionsWithEndDate[subscriptionsWithEndDate.length - 1];

        return selectedSubscriptionIndex >= majorSubscriptions.indexOf(highestEndDateSubscription);
    };

    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const cancelSwitchToSubscriptionHandler = async () => {
        setCancelSwitchToSubscriptionPending(true)

        const {status} = await dispatch(changePaymentMethod('No')).unwrap()

        if (status === 200) {
            setTimeout(() => {
                setCancelSwitchToSubscriptionPopupActive(false)
                setCancelSwitchToSubscriptionPending(false)
                setNotifyingModePopupData({
                    title: 'cancellation_of_the_switch_to_subscription',
                    description: 'you_have_canceled_the_switch_to_subscription'
                });
                dispatch(setPaymentMethodToChange('No'))
                dispatch(setPaymentMethodNow('Installs'))
                dispatch(setChangePaymentMethodStatus(false))
                setNotifyingModePopupActive(true)
            }, 2000)
        } else {
            setTimeout(() => {
                setCancelSwitchToSubscriptionPopupActive(false)
                setCancelSwitchToSubscriptionPending(false)
                setNotifyingModePopupData({
                    title: 'cancellation_of_the_switch_to_subscription',
                    description: 'failed_to_cancel_switch_to_subscription',
                    support: true
                });
                // dispatch(setPaymentMethodToChange('No'))
                // dispatch(setPaymentMethodNow('installs'))
                setNotifyingModePopupActive(true)
            }, 1000)
        }
    }

    const isPaymentMethodAwaitingToSetInstalls = change_payment_method_status && payment_method_to_change === 'Installs' && payment_method_now === 'Subscription'

    const switchToPerInstallPaymentHandler = async () => {
        setSwitchToPerInstallPaymentPending(true)

        const {status} = await dispatch(switchToPerInstallPayment(isPaymentPerInstallationSubMode)).unwrap()

        if (status === 200) {
            setTimeout(() => {
                setSwitchToPerInstallPaymentPopupActive(false)
                setSwitchToPerInstallPaymentPending(false)
                setNotifyingModePopupData(isPaymentPerInstallationSubMode ? {
                    title: 'pay_per_install_disabled',
                    description: ''
                } : {
                    title: 'pay_per_install_activated',
                    description: `${t('per_install_payment_explanation_1')} ${
                        convertDate(tomorrow, 'DMY')
                    }.
                    ${t('per_install_payment_explanation_2')}`,
                });
                if (isPaymentPerInstallationSubMode) {
                    dispatch(setSubscriptionPaymentMethodStatus(false))
                } else {
                    dispatch(setSubscriptionPaymentMethodStatus(true))
                }
                setNotifyingModePopupActive(true)
            }, 2000)
        } else {
            setTimeout(() => {
                setNotifyingModePopupData({
                    title: 'per_install_payment_activation',
                    description: 'failed_to_switch_to_pay_per_install_billing',
                });
                setSwitchToPerInstallPaymentPending(false)
                setSwitchToPerInstallPaymentPopupActive(false)
                setNotifyingModePopupActive(true)
            }, 1000)
        }
    }

    const switchPerInstallPaymentHandler = async () => {
        setSwitchToPerInstallPaymentPending(true)
        const methodToChange = isPaymentMethodAwaitingToSetInstalls ? 'No' : 'Installs'
        const {status} = await dispatch(changePaymentMethod(methodToChange)).unwrap()

        if (status === 200) {
            setTimeout(() => {
                setSwitchToPerInstallPaymentPopupActive(false)
                setSwitchToPerInstallPaymentPending(false)

                if (methodToChange === 'No') {
                    dispatch(setPaymentMethodToChange('No'))
                    dispatch(setPaymentMethodNow('Subscription'))
                    dispatch(setChangePaymentMethodStatus(false))
                } else if (methodToChange === 'Installs') {
                    dispatch(setPaymentMethodToChange('Installs'))
                    dispatch(setPaymentMethodNow('Subscription'))
                    dispatch(setChangePaymentMethodStatus(true))
                }

                // dispatch(setPaymentMethodToChange('No'))
                // dispatch(setPaymentMethodNow('installs'))
                // dispatch(setChangePaymentMethodStatus(false))
                setNotifyingModePopupData(isPaymentMethodAwaitingToSetInstalls ? {
                    title: 'pay_per_install_disabled',
                    description: ''
                } : {
                    title: 'pay_per_install_activated',
                    description: `${t('per_install_payment_explanation_1')} ${
                        convertDate(tomorrow, 'DMY')
                    }.
                    ${t('per_install_payment_explanation_2')}`,
                });
                // if (isPaymentPerInstallationSubMode) {
                //     dispatch(setSubscriptionPaymentMethodStatus(false))
                // } else {
                //     dispatch(setSubscriptionPaymentMethodStatus(true))
                // }
                setNotifyingModePopupActive(true)
            }, 2000)
        } else {
            setTimeout(() => {
                setNotifyingModePopupData({
                    title: 'per_install_payment_activation',
                    description: 'failed_to_switch_to_pay_per_install_billing',
                });
                setSwitchToPerInstallPaymentPending(false)
                setSwitchToPerInstallPaymentPopupActive(false)
                setNotifyingModePopupActive(true)
            }, 1000)
        }
    }

    // useEffect(() => {
    //     dispatch(getSubscriptionPaymentMethodStatus())
    // }, [dispatch]);

    return (
        <div
            className={`${s.subscriptionsWrapper} ${isCollapsedSidebar === "true" ? s.collapsedSidebar : ""}`}
        >
            <Header/>

            <ConfirmPopup
                icon={<SvgSelector id="subscriptions-icon"/>}
                active={isCancelSwitchToSubscriptionPopupActive}
                setActive={(value) => setCancelSwitchToSubscriptionPopupActive(value)}
                action={cancelSwitchToSubscriptionHandler}
                confirmBtnText={t('confirm')}
                title={t('cancellation_of_the_switch_to_subscription')}
                description={<>
                    {t('do_you_want_to_cancel_the_switch_to_subscription')}
                </>}
                forcedClose={false}
                pending={cancelSwitchToSubscriptionPending}
            />


            <ConfirmPopup
                icon={<SvgSelector id="subscriptions-icon"/>}
                active={isSwitchToPerInstallPaymentPopupActive}
                setActive={(value) => setSwitchToPerInstallPaymentPopupActive(value)}
                // action={switchToPerInstallPaymentHandler}
                action={switchPerInstallPaymentHandler}
                confirmBtnText={t(isPaymentMethodAwaitingToSetInstalls ? 'disable_button' : 'activate_button')}
                title={t(isPaymentMethodAwaitingToSetInstalls ? 'cancellation_pay_per_install_payment' : 'per_install_payment_activation')}
                description={<>
                    {t(isPaymentMethodAwaitingToSetInstalls ? 'about_to_disable_to_per_install_payment' : 'about_to_switch_to_per_install_payment')}
                </>}
                subDescription1={isPaymentMethodAwaitingToSetInstalls ? <></> : <>
                    {t('per_install_payment_explanation_1')}
                    {
                        convertDate(tomorrow, 'DMY')
                    }.
                    {t('per_install_payment_explanation_2')}
                </>}
                forcedClose={false}
                pending={switchToPerInstallPaymentPending}
            />

            {/*<ConfirmPopup*/}
            {/*    icon={<SvgSelector id="subscriptions-icon"/>}*/}
            {/*    active={isSwitchToPerInstallPaymentPopupActive}*/}
            {/*    setActive={(value) => setSwitchToPerInstallPaymentPopupActive(value)}*/}
            {/*    action={switchToPerInstallPaymentHandler}*/}
            {/*    confirmBtnText={t(isPaymentPerInstallationSubMode ? 'disable_button' : 'activate_button')}*/}
            {/*    title={t(isPaymentPerInstallationSubMode ? 'cancellation_pay_per_install_payment' : 'per_install_payment_activation')}*/}
            {/*    description={<>*/}
            {/*        {t(isPaymentPerInstallationSubMode ? 'about_to_disable_to_per_install_payment' : 'about_to_switch_to_per_install_payment')}*/}
            {/*    </>}*/}
            {/*    subDescription1={isPaymentPerInstallationSubMode ? <></> : <>*/}
            {/*        {t('per_install_payment_explanation_1')}*/}
            {/*        {*/}
            {/*            convertDate(tomorrow, 'DMY')*/}
            {/*        }.*/}
            {/*        {t('per_install_payment_explanation_2')}*/}
            {/*    </>}*/}
            {/*    forcedClose={false}*/}
            {/*    pending={switchToPerInstallPaymentPending}*/}
            {/*/>*/}

            <ConfirmPopup
                icon={<SvgSelector id="subscriptions-icon"/>}
                active={isConfirmSubscriptionActive}
                setActive={(value) => setConfirmSubscriptionActive(value)}
                action={processSubscriptionAction}
                confirmBtnText={isRenewSubscription ? t('renew_button') : t('activate_button')}
                title={t(isRenewSubscription ? 'tariff_renewal' : 'tariff_activation')}
                description={<>
                    {
                        `${t('you_are_about_to')}
                         ${isRenewSubscription ? t('renew') : t('activate')}`}
                    {" "}
                    <span className={s.highlight}>
                        {selectedTariff?.name}
                    </span>
                    {" " + t('subscription_word_in_popup_description')}
                </>}
                subDescription1={<>
                    {
                        getLanguage() === 'en'
                            ? <>
                            <span className={s.highlight}>
                                ${selectedTariff?.price}
                            </span>
                                {t('will_be_deducted_from_your_balance')}
                            </>
                            : <>
                                {t('will_be_deducted_from_your_balance')}
                                <span className={s.highlight}>
                                    {selectedTariff?.price}
                                </span>
                            </>
                    }
                    {
                        isRenewSubscription && t('renew_subscription_subdescription_info')
                    }
                </>}
                forcedClose={false}
                pending={activateSubscriptionPending}
            />
            <ConfirmPopup
                icon={<SvgSelector id="subscriptions-icon"/>}
                active={isDisableAutoRenewSubscriptionPopupActive}
                setActive={(value) => setDisableAutoRenewSubscriptionPopupActive(value)}
                action={disableAutoRenewSubscriptionHandler}
                confirmBtnText={t('disable_button')}
                title={t('subscription_auto_renewal_title')}
                description={<>
                    {t('disable_subscription_auto_renewal_popup_description')}{" "}
                    <span className={s.highlight}>
                        {selectedTariff?.name}
                    </span>?
                </>}
                subDescription1={<>
                    {t('subscription_auto_renewal_popup_subdescription')}
                </>}
                forcedClose={false}
                pending={disableAutoRenewSubscriptionPending}
            />
            <ConfirmPopup
                icon={<SvgSelector id="subscriptions-icon"/>}
                active={isEnableAutoRenewSubscriptionPopupActive}
                setActive={(value) => setEnableAutoRenewSubscriptionPopupActive(value)}
                action={enableAutoRenewSubscriptionHandler}
                confirmBtnText={t('enable_button')}
                title={t('subscription_auto_renewal_title')}
                description={<>
                    {t('enable_subscription_auto_renewal_popup_description')}{" "}
                    <span className={s.highlight}>
                        {selectedTariff?.name}
                    </span>
                    {" "}?
                </>}
                subDescription1={<>
                    {t('enable_subscription_auto_renewal_subdescription')}
                </>}
                forcedClose={false}
                pending={enableAutoRenewSubscriptionPending}
            />
            <SubscriptionActivatedPopup
                icon={<SvgSelector id="subscriptions-icon"/>}
                active={isNotifyingModePopupActive}
                setActive={(value) => setNotifyingModePopupActive(value)}
                title={t(notifyingModePopupData?.title)}
                description={

                    notifyingModePopupData?.support ?
                        <>
                            {t(notifyingModePopupData?.description)}
                            . {t("contact")}{" "}
                            <a
                                href="https://t.me/TL_supp_wwa_vados"
                                target="_blank"
                                rel="noreferrer"
                            >
                                {t("supportPopupMessage")}
                            </a>
                        </> : t(notifyingModePopupData?.description)
                }
                notifyingModePopupData={notifyingModePopupData}
                forcedClose={true}
                notifyingMode
            />
            <ActivateSubscriptionTopUpBalancePopup
                isRenewSubscription={isRenewSubscription}
                subscriptionName={selectedTariff?.name}
                subscriptionPrice={selectedTariff?.price}
                active={isSubscriptionsTopUpBalancePopupActive}
                setActive={setSubscriptionsTopUpBalancePopupActive}
                action={value => setSubscriptionsTopUpBalancePopupActive(value)}
            />
            <div className={s.pageContent}>
                <div className={s.subscriptionsContainer}>

                    {
                        // change_payment_method_status && subscriptionPaymentMethodToChange &&
                        change_payment_method_status && subscriptionPaymentMethodToChange && payment_method_now === 'Installs' &&
                        <div className={s.switchingToPerInstallPaymentWarning}>
                            <div className={s.messageContentWrapper}>

                                <SvgSelector id='warning-shield-icon'/>
                                <span>
                                    {t('subscription_payment_method_to_change_text_1')}
                                    {subscriptionPaymentMethodToChange?.name}
                                    {t('subscription_payment_method_to_change_text_2')}
                                </span>
                            </div>

                            <button
                                className={s.whiteBorderBtn}
                                disabled={isDisabledButtons}
                                onClick={() => {
                                    setCancelSwitchToSubscriptionPopupActive(true)
                                }}
                            >
                                {/*{t('switch_back_to_pay_per_install_billing')}*/}
                                {t('cancel_the_switch_to_subscription')}
                            </button>

                        </div>
                    }

                    {
                        // activeSubscription && isPaymentPerInstallationSubMode &&
                        change_payment_method_status && payment_method_to_change === 'Installs' &&
                        <div className={s.switchingToPerInstallPaymentWarning}>
                            <div className={s.messageContentWrapper}>

                                <SvgSelector id='warning-shield-icon'/>
                                <span>{t('switching_at_00')}</span>
                            </div>

                            <button
                                className={s.whiteBorderBtn}
                                disabled={isDisabledButtons}
                                onClick={() => {
                                    setSwitchToPerInstallPaymentPopupActive(true)
                                }}
                            >
                                {t('disable_pay_per_install_billing')}
                            </button>

                        </div>
                    }

                    {
                        activeSubscription && activeSubscription?.name !== "Test" &&
                        <div className={s.currentSubscriptionInfo}>
                            <div className={s.leftPart}>
                                <div className={s.currentTariff}>
                                    <span>{t('your_current_tariff')}:</span>
                                    <span className={s.highlighted}>{activeSubscription?.name}</span>
                                </div>
                                <div className={s.buttonWrapper}>
                                    <button
                                        className={s.primaryBtn}
                                        disabled={isDisabledButtons || activeSubscription?.name === "Test"}
                                        onClick={() => {
                                            if (payment_method_now === 'Subscription' && payment_method_to_change === 'Installs' && change_payment_method_status) {
                                                return showSnackbar(t("cancel_pay_per_install_payment"), snackbar_warning);
                                            } else {

                                                if (activeSubscription?.renew_subscription) {
                                                    onDisableAutoRenewSubscription(activeSubscription?.name)
                                                } else {
                                                    onEnableAutoRenewSubscription(activeSubscription?.name)
                                                }
                                            }
                                        }}
                                    >
                                        {t('auto_renewal_title')}
                                    </button>
                                </div>
                            </div>
                            <div className={s.rightPart}>
                                <div className={s.topContainer}>
                                    <div className={s.tariffDate}>
                                        <span>{t('tariff_is_active')}:</span>
                                        <span
                                            className={`${s.highlighted} ${
                                                payment_method_now === SUBSCRIPTION_PAYMENT_METHOD
                                                && !activeSubscription?.active_by_time
                                                    ? s.red : ''
                                            }`}>{startDateOfSubscription} - {endDateOfSubscription}</span>
                                    </div>
                                    <div className={s.limits}>
                                        <span>{t('limits')}:</span>
                                        <ul>
                                            {subscriptionLimits.map(({iconId, defaultKey, subscriptionKey}) => (
                                                <li key={iconId}>
                                                    <SvgSelector id={iconId}/>
                                                    <span>
                                                      {!isInitialInstallsLimits
                                                          ? activeSubscription?.[defaultKey] ??
                                                          <SvgSelector id='all-in-icon'/>
                                                          : activeSubscription?.[subscriptionKey] ??
                                                          <SvgSelector id='all-in-icon'/>}
                                                    </span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className={s.bottomContainer}>
                                    <div className={s.autoRenewMode}>
                                        <span>{t('auto_renewal_title')}:</span>
                                        <span
                                            className={`${s.highlighted} ${activeSubscription?.renew_subscription ? s.green : s.red}`}>
                                        {
                                            activeSubscription?.renew_subscription
                                                ? t('on')
                                                : t('off')
                                        }
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }


                    {
                        !fetchSubscriptionsPending && !activeSubscription &&
                        <div className={s.installationFeeModeInfoContainer}>
                            {
                                !activeSubscription && <div className={s.currentFeeMode}>
                                    <div className={s.topContainer}>
                                        <span>{t('your_current_tariff')}:</span>
                                        <span className={s.highlighted}>{t('pay_per_install_billing')}</span>
                                    </div>
                                    <div className={s.bottomContainer}>
                                        <div className={s.installationPrices}>
                                            {t('pay_per_install_plan')}
                                            <span> iOS / PWA / Android - $0.1</span>
                                        </div>
                                        <div className={s.status}>
                                            {t('status')}:{" "}
                                            <span>{t('active')}</span>
                                        </div>
                                    </div>
                                </div>
                            }

                            {
                                !isTestSubscriptionHidden && !activeSubscription &&
                                <div
                                    className={s.testTariffCard}
                                    style={{backgroundImage: `url(${subscriptionsPurpleBG})`}}
                                >
                                    <div className={s.cardInfo}>
                                        <p className={s.title}>
                                            {t('activate_test_subscription_text')}
                                        </p>

                                        <p className={s.desc}>
                                            <span>Trial / Test:</span>{" "}{" "}{
                                            `${t('for')} ${testTariff?.price} ${t('test_subscription_description')}`
                                        }
                                        </p>
                                    </div>
                                    <div className={s.action}>
                                        <button
                                            className={s.whiteBorderBtn}
                                            disabled={isDisabledButtons}
                                            onClick={() => {
                                                if (change_payment_method_status && subscriptionPaymentMethodToChange?.name === 'Test') {
                                                    // return showSnackbar(t("cancel_the_switch_to_subscription_to_continue"), snackbar_warning);

                                                    return showSnackbar(
                                                        getLanguage() === 'en' ? `${subscriptionPaymentMethodToChange?.name} 
                                                                          ${t('subscription_switch_pending')}`
                                                            : `${t('subscription_switch_pending')} ${subscriptionPaymentMethodToChange?.name}`,
                                                        snackbar_warning
                                                    )

                                                    // return showSnackbar(t("cancel_the_switch_to_subscription_to_continue"), snackbar_warning);
                                                } else {
                                                    setRenewSubscription(false)
                                                    onActivateSubscription(testTariff?.name)
                                                }
                                            }}
                                        >
                                            {t('activate')}
                                        </button>
                                    </div>
                                </div>
                            }
                        </div>
                    }


                    {
                        fetchSubscriptionsPending
                            ? <CustomSkeleton styles={s.testTariffSkeletonStyle}/>
                            : !isTestSubscriptionHidden && testTariff?.is_active && testTariff?.active_by_time &&
                            <div
                                className={s.testTariffInfo}
                                style={{backgroundImage: `url(${subscriptionsPurpleBG})`}}
                            >
                                <div className={s.activeTestTariffContent}>
                                    <div className={s.leftSide}>
                                        <div className={s.header}>
                                            <p className={s.title}>
                                                {t('your_current_tariff')}:{" "}
                                                {testTariff?.name}
                                            </p>
                                        </div>
                                        <div className={s.installsInfo}>
                                            <span>{t('limits')}:</span>
                                            <ul className={s.detailsList}>
                                                {subscriptionLimits.map(({iconId, defaultKey, subscriptionKey}) => (
                                                    <li key={iconId}>
                                                        <SvgSelector id={iconId}/>
                                                        <span>
                                          {fetchSubscriptionsPending
                                              ? "---"
                                              : !isInitialInstallsLimits
                                                  ? activeSubscription?.[defaultKey] === undefined
                                                      ? "---"
                                                      : activeSubscription?.[defaultKey] === null
                                                          ? <SvgSelector id='all-in-icon'/>
                                                          : activeSubscription?.[defaultKey]
                                                  : activeSubscription?.[subscriptionKey] === undefined
                                                      ? "---"
                                                      : activeSubscription?.[subscriptionKey] === null
                                                          ? <SvgSelector id='all-in-icon'/>
                                                          : activeSubscription?.[subscriptionKey]}
                                        </span>
                                                    </li>
                                                ))}

                                                {/*{*/}
                                                {/*    testSubscriptionInstallsList?.map(({installName, count}) => {*/}

                                                {/*        return (*/}
                                                {/*            <li key={installName}>*/}
                                                {/*                {*/}
                                                {/*                    (count === null || count > 0) &&*/}
                                                {/*                    <SvgSelector id='circle-check'/>*/}
                                                {/*                }*/}
                                                {/*                {*/}
                                                {/*                    count === 0 &&*/}
                                                {/*                    <SvgSelector id='circle-cross'/>*/}
                                                {/*                }*/}
                                                {/*                <span>*/}
                                                {/*                {installName} - {displayInstalls(count)}*/}
                                                {/*            </span>*/}
                                                {/*            </li>*/}
                                                {/*        )*/}
                                                {/*    })*/}
                                                {/*}*/}

                                            </ul>
                                        </div>
                                    </div>


                                    <div className={s.descriptionMessage}>
                                        {t('uac_access')}
                                    </div>

                                    {/*{*/}
                                    {/*    !change_payment_method_status && payment_method_to_change !== 'Installs' &&*/}

                                    {/*    <div className={s.rightSide}>*/}
                                    {/*        <div className={s.perInstallPaymentInfo}>*/}
                                    {/*            <p>{t('switch_to_payment_per_installation')}</p>*/}
                                    {/*            <p>{t('tariff')} - <span>iOS / PWA / Android - $ 0.1</span></p>*/}
                                    {/*        </div>*/}
                                    {/*        <button*/}
                                    {/*            className={s.whiteBorderBtn}*/}
                                    {/*            disabled={isDisabledButtons}*/}
                                    {/*            onClick={() => {*/}
                                    {/*                setSwitchToPerInstallPaymentPopupActive(true)*/}
                                    {/*            }}*/}
                                    {/*        >*/}
                                    {/*            {t('payment_per_install')}*/}
                                    {/*        </button>*/}
                                    {/*    </div>*/}
                                    {/*}*/}
                                </div>
                            </div>
                    }

                    {/*activeSubscription && activeSubscription?.name !== "Test" ? s.fourCards : ''*/}
                    <div className={`
                        ${s.cardsContainer} 
                        ${activeSubscription ? s.fourCards : ''}
                    `}>

                        {
                            // activeSubscription && activeSubscription?.name !== "Test" &&
                            // activeSubscription &&
                            <div className={`${s.card} 
                        `}
                                 style={{backgroundImage: `url(${subscriptionsGreenBG})`}}
                            >
                                <div className={s.header}>
                                    Installation fee
                                    <div className={s.tariffNumber}>0</div>
                                </div>
                                <div className={s.body}>
                                    <div className={s.priceContainer}>

                                        <div className={s.price}>
                                            $ 0.1
                                            <span className={s.month}>/{t('per_install')}</span>
                                        </div>
                                        <div className={s.fastDescription}>
                                            <div className={s.desc}>
                                                {t('installation_fee_desc_1')}
                                            </div>
                                            <div className={s.desc}>
                                                {t('installation_fee_desc_2')}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={s.buttonsContainer}>
                                        {
                                            <button
                                                disabled={payment_method_now === "Installs" || isDisabledButtons}
                                                className={s.primaryBtn}
                                                onClick={() => {
                                                    setSwitchToPerInstallPaymentPopupActive(true)
                                                }}
                                            >
                                                {/*{*/}
                                                {/*    isPaymentPerInstallationSubMode ? t('button_cancel') :*/}
                                                {/*        t('switch')*/}
                                                {/*}*/}
                                                {
                                                    change_payment_method_status && payment_method_to_change === 'Installs' ? t('button_cancel') :
                                                        t('switch')
                                                }
                                            </button>
                                        }

                                    </div>
                                    <div className={s.benefitsContainer}>

                                        <ul className={s.benefitsList}>
                                            <p className={s.title}>
                                                {t('installation_fee_tariffs')}:
                                            </p>
                                            <li>
                                                <SvgSelector id='transparent-circle-check'/>
                                                <span>
                                                Android - $0.1
                                            </span>
                                            </li>
                                            <li>
                                                <SvgSelector id='transparent-circle-check'/>
                                                <span>
                                                IOS - $0.1
                                            </span>
                                            </li>
                                            <li>
                                                <SvgSelector id='transparent-circle-check'/>
                                                <span>
                                                PWA - $0.1
                                            </span>
                                            </li>
                                            <li>
                                                <SvgSelector id='transparent-circle-check'/>
                                                <span>
                                                {t('uac_access')}
                                            </span>
                                            </li>
                                            <li>
                                                <SvgSelector id='transparent-circle-check'/>
                                                <span>
                                                {t('presence_10_team_members')}
                                            </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        }

                        {
                            fetchSubscriptionsPending ? Array.from({length: 3}).map((_, index) => (
                                    <div key={index} className={s.skeletonCardWrapper}>
                                        <CustomSkeleton styles={s.skeletonStyle}/>
                                    </div>
                                )) :

                                majorSubscriptions.map(({
                                                            is_active,
                                                            end_date,
                                                            start_date,
                                                            renew_subscription,
                                                            name,
                                                            description,
                                                            benefitsName,
                                                            bgImage,
                                                            disabledBgImage,
                                                            extraBenefits,
                                                            price,
                                                            free_domains,
                                                            pwa_install_count,
                                                            ios_install_count,
                                                            android_install_count,
                                                            subscription_android_install_count,
                                                            subscription_pwa_install_count,
                                                            subscription_ios_install_count,
                                                            subscription_free_domains,
                                                        }, index) => {

                                    const {extraBenefitsName, extraBenefitsList} = extraBenefits


                                    // const installsList = [
                                    //     {
                                    //         installName: 'PWA',
                                    //         count: !isResetCounters && is_active ? pwa_install_count : subscription_pwa_install_count
                                    //     },
                                    //     {
                                    //         installName: 'IOS',
                                    //         count: !isResetCounters && is_active ? ios_install_count : subscription_ios_install_count
                                    //     },
                                    //     {
                                    //         installName: 'ANDROID',
                                    //         count: !isResetCounters && is_active ? android_install_count : subscription_android_install_count
                                    //     }
                                    // ]

                                    const installsList = [
                                        {
                                            installName: 'PWA',
                                            count: subscription_pwa_install_count
                                        },
                                        {
                                            installName: 'IOS',
                                            count: subscription_ios_install_count
                                        },
                                        {
                                            installName: 'ANDROID',
                                            count: subscription_android_install_count
                                        }
                                    ]

                                    const showedDomains = !isInitialInstallsLimits && is_active ? free_domains : subscription_free_domains

                                    return (
                                        <div className={`${s.card} ${is_active ? s.activated : ""}`}
                                             key={name}
                                             style={{backgroundImage: `url(${is_active ? disabledBgImage : bgImage})`}}
                                        >
                                            <div className={s.header}>
                                                {name}
                                                <div className={s.tariffNumber}>{index + 1}</div>
                                            </div>
                                            <div className={s.body}>
                                                <div className={s.priceContainer}>

                                                    <div className={s.price}>
                                                        $ {price}
                                                        <span className={s.month}>/{t('per_month')}</span>
                                                    </div>
                                                    <div className={s.fastDescription}>
                                                        {t(description)}
                                                    </div>
                                                </div>
                                                <div className={s.buttonsContainer}>
                                                    {
                                                        !is_active &&
                                                        <button
                                                            disabled={isDisabledButtons}
                                                            className={s.primaryBtn}
                                                            onClick={() => {

                                                                if (change_payment_method_status && subscriptionPaymentMethodToChange?.name === name) {
                                                                    // return showSnackbar(t("cancel_the_switch_to_subscription_to_continue"), snackbar_warning);

                                                                    return showSnackbar(
                                                                        getLanguage() === 'en' ? `${subscriptionPaymentMethodToChange?.name} 
                                                                          ${t('subscription_switch_pending')}`
                                                                            : `${t('subscription_switch_pending')} ${subscriptionPaymentMethodToChange?.name}`,
                                                                        snackbar_warning
                                                                    )

                                                                    // return showSnackbar(t("cancel_the_switch_to_subscription_to_continue"), snackbar_warning);
                                                                }

                                                                if (
                                                                    payment_method_to_change === 'Installs' && change_payment_method_status &&
                                                                    payment_method_now === 'Subscription'
                                                                ) {
                                                                    return showSnackbar(t("cancel_switch_to_per_install_billing_to_continue"), snackbar_warning);
                                                                } else {
                                                                    setRenewSubscription(false)
                                                                    onActivateSubscription(name)
                                                                }

                                                                // if (canBuySubscription(index)) {
                                                                // } else {
                                                                //     showSnackbar(t("cannot_buy_this_subscription"), snackbar_warning);
                                                                // }
                                                            }}
                                                        >
                                                            {t('activate_button')}
                                                        </button>
                                                    }
                                                    {
                                                        is_active && <button
                                                            disabled={isDisabledButtons}
                                                            className={s.primaryBtn}
                                                            onClick={() => {
                                                                if (change_payment_method_status && subscriptionPaymentMethodToChange?.name === name) {
                                                                    // return showSnackbar(t("cancel_the_switch_to_subscription_to_continue"), snackbar_warning);

                                                                    return showSnackbar(
                                                                        getLanguage() === 'en' ? `${subscriptionPaymentMethodToChange?.name} 
                                                                          ${t('subscription_switch_pending')}`
                                                                            : `${t('subscription_switch_pending')} ${subscriptionPaymentMethodToChange?.name}`,
                                                                        snackbar_warning
                                                                    )

                                                                    // return showSnackbar(t("cancel_the_switch_to_subscription_to_continue"), snackbar_warning);
                                                                }

                                                                if (
                                                                    payment_method_to_change === 'Installs' && change_payment_method_status &&
                                                                    payment_method_now === 'Subscription'
                                                                ) {
                                                                    return showSnackbar(t("cancel_switch_to_per_install_billing_to_continue"), snackbar_warning);
                                                                } else {
                                                                    setRenewSubscription(true)
                                                                    onActivateSubscription(name)
                                                                }
                                                            }}
                                                        >
                                                            {t('renew_button')}
                                                        </button>
                                                    }
                                                </div>
                                                <div className={s.benefitsContainer}>

                                                    <ul className={s.benefitsList}>
                                                        <p className={s.title}>
                                                            {t(benefitsName)}:
                                                        </p>

                                                        {
                                                            (name === 'Start' || name === 'Wild Star') &&
                                                            <li>
                                                                <SvgSelector id='transparent-circle-check'/>
                                                                <span>
                                                                    {t('unlimited_pwa_installations')}
                                                                </span>
                                                            </li>
                                                        }

                                                        {
                                                            installsList
                                                                ?.filter(({installName}) =>
                                                                    !((name === 'Start' || name === 'Wild Star') && installName === 'PWA')
                                                                    // &&
                                                                    // !(name === 'Android Star' && installName === 'Android') // Фільтрація для Android Star
                                                                )
                                                                .map(({installName, count}) => {
                                                                    const installsValue = displayInstalls(count);
                                                                    const isValueAllIn = installsValue === "All in";
                                                                    let labelText;

                                                                    // Умова для 'Wild Star' та 'Android Star' з "All in"
                                                                    if (getLanguage() === 'en') {
                                                                        if (name === 'Wild Star' && isValueAllIn) {
                                                                            labelText = `Unlimited ${installName} app installations`;
                                                                        } else if (name === 'Android Star' && isValueAllIn) {
                                                                            labelText = `Unlimited ${installName} app installations`; // Для Android Star
                                                                        } else if (isValueAllIn) {
                                                                            labelText = `Access to all ${installName} applications`;
                                                                        } else {
                                                                            labelText = `Access to ${installName} applications - ${installsValue}`;
                                                                        }
                                                                    } else {
                                                                        const key = (name === 'Wild Star' && isValueAllIn) || (name === 'Android Star' && isValueAllIn)  // Додано для Android Star
                                                                            ? 'unlimited_installations'
                                                                            : isValueAllIn
                                                                                ? 'access_to_all_apps'
                                                                                : 'access_to_apps';
                                                                        labelText = `${t(key)} ${installName}${!isValueAllIn ? ` - ${installsValue}` : ''}`;
                                                                    }


                                                                    return (
                                                                        <li key={installName}>
                                                                            <SvgSelector id='transparent-circle-check'/>
                                                                            <span>
                            {labelText}
                                                                                {name === WILD && t('plus_private_apps_in_bot')}
                        </span>
                                                                        </li>
                                                                    );
                                                                })
                                                        }

                                                        {
                                                            extraBenefitsList.map((item, index) => (
                                                                <li key={index}>
                                                                    <SvgSelector id={'transparent-circle-check'}/>
                                                                    <span>
                    {t(item)}
                </span>
                                                                </li>
                                                            ))
                                                        }
                                                    </ul>


                                                    {/*<ul className={s.benefitsList}>*/}
                                                    {/*    <p className={s.title}>*/}
                                                    {/*        {t(benefitsName)}:*/}
                                                    {/*    </p>*/}

                                                    {/*    {*/}
                                                    {/*        (name === 'Start' || name === 'Wild Star') &&*/}
                                                    {/*        <li>*/}
                                                    {/*            <SvgSelector id='transparent-circle-check'/>*/}
                                                    {/*            <span>*/}
                                                    {/*                {t('unlimited_pwa_installations')}*/}
                                                    {/*            </span>*/}
                                                    {/*        </li>*/}
                                                    {/*    }*/}

                                                    {/*    /!*unlimited_installations*!/*/}

                                                    {/*    {*/}
                                                    {/*        installsList*/}
                                                    {/*            ?.filter(*/}
                                                    {/*                ({installName}) =>*/}
                                                    {/*                    !((name === 'Start' || name === 'Wild Star') && installName === 'PWA')*/}
                                                    {/*            )*/}
                                                    {/*            .map(({installName, count}) => {*/}
                                                    {/*                const installsValue = displayInstalls(count);*/}
                                                    {/*                const isValueAllIn = installsValue === "All in";*/}

                                                    {/*                let labelText;*/}

                                                    {/*                if (getLanguage() === 'en') {*/}
                                                    {/*                    // англійська*/}
                                                    {/*                    if (name === 'Wild Star' && isValueAllIn) {*/}
                                                    {/*                        labelText = `Unlimited ${installName} app installations`;*/}
                                                    {/*                    } else if (isValueAllIn) {*/}
                                                    {/*                        labelText = `Access to all ${installName} applications`;*/}
                                                    {/*                    } else {*/}
                                                    {/*                        labelText = `Access to ${installName} applications - ${installsValue}`;*/}
                                                    {/*                    }*/}
                                                    {/*                } else {*/}
                                                    {/*                    // російська чи українська – через ключі i18n*/}
                                                    {/*                    const key = name === 'Wild Star' && isValueAllIn*/}
                                                    {/*                        ? 'unlimited_installations'*/}
                                                    {/*                        : isValueAllIn*/}
                                                    {/*                            ? 'access_to_all_apps'*/}
                                                    {/*                            : 'access_to_apps';*/}
                                                    {/*                    // Наприклад: "Безлімітні інсталяції додатків iOS" або "Доступ до додатків iOS – 5"*/}
                                                    {/*                    labelText = `${t(key)} ${installName}${!isValueAllIn ? ` - ${installsValue}` : ''}`;*/}
                                                    {/*                }*/}

                                                    {/*                return (*/}
                                                    {/*                    <li key={installName}>*/}
                                                    {/*                        <SvgSelector id='transparent-circle-check'/>*/}
                                                    {/*                        <span>*/}

                                                    {/*                            /!*unlimited_installations*!/*/}
                                                    {/*                            /!*{t(*!/*/}
                                                    {/*                            /!*    getLanguage() === 'en' ? '' :*!/*/}

                                                    {/*                            /!*    name === 'Wild Star' && isValueAllIn ?*!/*/}
                                                    {/*                            /!*    'unlimited_installations' :*!/*/}

                                                    {/*                            /!*    isValueAllIn ? 'access_to_all_apps' : 'access_to_apps')}*!/*/}


                                                    {/*                            /!*{' '}*!/*/}

                                                    {/*                            {labelText}*/}

                                                    {/*                            /!*{installName}*!/*/}
                                                    {/*                            /!*{getLanguage() === 'en' && 'app'}*!/*/}
                                                    {/*                            /!*{!isValueAllIn && ` - ${installsValue}`}*!/*/}
                                                    {/*                            {name === WILD && t('plus_private_apps_in_bot')}*/}
                                                    {/*                        </span>*/}
                                                    {/*                    </li>*/}
                                                    {/*                );*/}
                                                    {/*            })*/}
                                                    {/*    }*/}


                                                    {/*    /!*{*!/*/}
                                                    {/*    /!*    installsList?.map(({installName, count}) => {*!/*/}
                                                    {/*    /!*        const installsValue = displayInstalls(count)*!/*/}
                                                    {/*    /!*        const isValueAllIn = displayInstalls(count) === "All in"*!/*/}


                                                    {/*    /!*        return (*!/*/}
                                                    {/*    /!*            <li key={installName}>*!/*/}
                                                    {/*    /!*                <SvgSelector id='transparent-circle-check'/>*!/*/}
                                                    {/*    /!*                <span>*!/*/}
                                                    {/*    /!*                    {t(isValueAllIn ? 'access_to_all_apps' : 'access_to_apps')}*!/*/}
                                                    {/*    /!*                    {installName}*!/*/}
                                                    {/*    /!*                    {*!/*/}
                                                    {/*    /!*                        !isValueAllIn && ` - ${installsValue}`*!/*/}
                                                    {/*    /!*                    }*!/*/}
                                                    {/*    /!*                    {*!/*/}
                                                    {/*    /!*                        name === WILD && t('plus_private_apps_in_bot')*!/*/}
                                                    {/*    /!*                    }*!/*/}
                                                    {/*    /!*                </span>*!/*/}
                                                    {/*    /!*            </li>*!/*/}
                                                    {/*    /!*        )*!/*/}
                                                    {/*    /!*    })*!/*/}
                                                    {/*    /!*}*!/*/}
                                                    {/*    {*/}
                                                    {/*        extraBenefitsList.map((item, index) => (*/}
                                                    {/*            <li key={index}>*/}
                                                    {/*                <SvgSelector*/}
                                                    {/*                    id={'transparent-circle-check'}/>*/}
                                                    {/*                <span>*/}
                                                    {/*                    {t(item)}*/}
                                                    {/*                </span>*/}
                                                    {/*            </li>*/}
                                                    {/*        ))*/}
                                                    {/*    }*/}
                                                    {/*</ul>*/}

                                                    {/*{*/}
                                                    {/*    extraBenefitsList.length > 0 && <ul className={s.benefitsList}>*/}
                                                    {/*        <p className={s.title}>*/}
                                                    {/*            {extraBenefitsName}*/}
                                                    {/*        </p>*/}
                                                    {/*        {*/}
                                                    {/*            extraBenefitsList.map((item, index) => (*/}
                                                    {/*                <li key={index}>*/}
                                                    {/*                    <SvgSelector*/}
                                                    {/*                        id={is_active ? 'circle-check' : 'transparent-circle-check'}/>*/}
                                                    {/*                    <span>*/}
                                                    {/*                    {item}*/}
                                                    {/*                </span>*/}
                                                    {/*                </li>*/}
                                                    {/*            ))*/}
                                                    {/*        }*/}
                                                    {/*        {*/}
                                                    {/*            (showedDomains || showedDomains === 0) && (*/}
                                                    {/*                <li key={index}>*/}
                                                    {/*                    <SvgSelector*/}
                                                    {/*                        id={*/}
                                                    {/*                            !is_active*/}
                                                    {/*                                ? 'transparent-circle-check'*/}
                                                    {/*                                : (showedDomains > 0 ? 'circle-check' : 'circle-cross')*/}
                                                    {/*                        }*/}
                                                    {/*                    />*/}
                                                    {/*                    <span>*/}
                                                    {/*                        {t('free_domains')}: {showedDomains} (IOS/PWA)*/}
                                                    {/*                    </span>*/}
                                                    {/*                </li>*/}
                                                    {/*            )*/}
                                                    {/*        }*/}

                                                    {/*    </ul>*/}
                                                    {/*}*/}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Subscriptions;